import { ICommonIconProps } from '@/types/shared'
import * as React from 'react'

interface Props extends ICommonIconProps {
  rect?: React.SVGProps<SVGRectElement>
}

export const SvgScienceIcon: React.FC<Props> = ({
  width = '48',
  height = '48',
  fill = 'none',
  stroke = 'white',
  className,
  rect,
}) => {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      className={className}
    >
      {rect && (
        <rect
          width={rect.width}
          height={rect.height}
          rx={rect.rx || '10'}
          fill={rect.fill || '#7064FF'} //v8-violet
        />
      )}
      <path
        d="M31.428 27.4282C31.1488 27.149 30.7932 26.9587 30.406 26.8812L28.0185 26.4037C26.7101 26.1421 25.3519 26.324 24.1585 26.9207L23.8411 27.0793C22.6477 27.676 21.2895 27.8579 19.9811 27.5963L18.0494 27.2099C17.3937 27.0788 16.7158 27.284 16.2429 27.7569M19.9998 16H27.9998L26.9998 17V22.1716C26.9998 22.702 27.2105 23.2107 27.5856 23.5858L32.5856 28.5858C33.8455 29.8457 32.9532 32 31.1714 32H16.8282C15.0464 32 14.1541 29.8457 15.414 28.5858L20.414 23.5858C20.7891 23.2107 20.9998 22.702 20.9998 22.1716V17L19.9998 16Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
